<template>
  <div class="container position-relative d-flex justify-content-center align-items-center text-center">
    <!-- Background 404 Text -->
    <div class="background-text">404</div>

    <!-- Foreground Content -->
    <div class="body">
      <h5 class="mt-3">Page Not Found</h5>
      <p>This Page doesn't exist or was removed! We suggest you go back to home.</p>
      <router-link :to="'/'" class="nav-link p-0">
        <button type="button" class="btn hk-btn-demo-main me-2">
          <i class="bi bi-arrow-left me-2"></i>
          Back to home
        </button>
      </router-link>
    </div>
  </div>
</template>

<style scoped>
/* Background 404 Text */
.background-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 15rem;
  color: lightgray;
  z-index: 1;
  user-select: none;
  font-weight: bold;
  opacity: 0.2;
}

/* Foreground Content */
.body {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Ensure full height and vertical centering */
.container {
  height: 100vh;
}
</style>
